import React, { useState, useEffect, useContext } from 'react';
import { message, Table } from 'antd';
import dayjs from 'dayjs';
import axios from 'axios';
import { LoginContext } from '../../context/loginContext';

const CPosicionCliente = () => {
  const { user } = useContext(LoginContext);
  const [articulos, setArticulos] = useState([]);

  useEffect(() => {
    fetchArticulosCliente();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchArticulosCliente = async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_URL}/movimientos/articulos/por-cliente/${user.user.id}`,
        { headers: { Authorization: `Bearer ${user.token}` } }
      );

      const articulosConPosiciones = data.map((articulo) => ({
        ...articulo,
        posiciones: articulo.posiciones || [],
        nombreArticulo: articulo.articulo?.nombre || '',
        marca: articulo.articulo?.idmarca?.nombre || '',
        categoria: articulo.articulo?.idcategoria?.nombre || '',
        unidadDeMedida: articulo.articulo?.unidadDeMedida || '',
        cantidadDisponible: articulo.cantidad ?? 0,
      }));

      articulosConPosiciones.sort((a, b) => b.cantidadDisponible - a.cantidadDisponible);
      setArticulos(articulosConPosiciones);
    } catch {
      message.error('Error al cargar artículos del cliente');
    }
  };

  // Columnas de la tabla principal
  const columns = [
    { title: 'Nombre Artículo', dataIndex: 'nombreArticulo', key: 'nombreArticulo' },
    { title: 'Marca', dataIndex: 'marca', key: 'marca' },
    { title: 'Categoría', dataIndex: 'categoria', key: 'categoria' },
    { title: 'Unidad de Medida', dataIndex: 'unidadDeMedida', key: 'unidadDeMedida' },
    { title: 'Cantidad Total', dataIndex: 'cantidadDisponible', key: 'cantidadDisponible', render: (cantidad) => Number(cantidad).toFixed(2) },
  ];

  // Render del detalle expandido (posicion + lote + vencimiento)
  const expandedRowRender = (record) => {
    // Aplanamos posiciones -> filas por (posición + lote + vencimiento)
    const detalle = (record.posiciones || []).flatMap((pos) => {
      const lotes = Array.isArray(pos.lotes) ? pos.lotes : [];
      if (!lotes.length) {
        // Si no hay lotes, mostramos la cantidad total de la posición
        return [
          {
            key: `${pos.posicion}-nl-nf`,
            posicion: pos.posicion,
            lote: '—',
            fechaVencimiento: '—',
            cantidad: pos.cantidad ?? 0,
          },
        ];
      }
      return lotes.map((l) => ({
        key: `${pos.posicion}-${l.lote || 'nl'}-${l.fechaVencimiento || 'nf'}`,
        posicion: pos.posicion,
        lote: l.lote || '—',
        fechaVencimiento: l.fechaVencimiento ? dayjs(l.fechaVencimiento).format('YYYY-MM-DD') : '—',
        cantidad: l.cantidad ?? 0,
      }));
    });

    const innerColumns = [
      { title: 'Lote', dataIndex: 'lote', key: 'lote' },
      { title: 'Vencimiento', dataIndex: 'fechaVencimiento', key: 'fechaVencimiento' },
      { title: 'Cantidad', dataIndex: 'cantidad', key: 'cantidad', render: (cantidad) => Number(cantidad).toFixed(2) },
    ];

    return (
      <Table
        columns={innerColumns}
        dataSource={detalle}
        pagination={false}
        rowKey="key"
        size="small"
      />
    );
  };

  return (
    <Table
      columns={columns}
      dataSource={articulos}
      rowKey={(r) => r?.articulo?._id}  // más seguro que 'articulo._id'
      expandable={{
        expandedRowRender,
        rowExpandable: (record) => (record.posiciones || []).length > 0,
        expandRowByClick: true,
      }}
      pagination={{
        pageSize: 10,
        total: articulos.length,
        showTotal: (total) => `Total ${total} artículos`,
      }}
      scroll={{ x: 800 }}
    />
  );
};

export default CPosicionCliente;